// There's no difference between page header and page sidebar header. Re-exporting is just for naming purposes.
import PageHeader from "../page-header";
export default PageHeader;
